module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07407_banner_800x600.19976dc0.png";